import getNative from './_getNative';
import root from './_root';

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

export default Set;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_Set.js
// module id = 175
// module chunks = 0